import { Button } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { lynxButtonStyles } from "./LynxButtonStyles";
import { ReactComponent as Spinner } from "../../icons/Spinner.svg";
import { LynxButtonProps } from "./LynxButtonProps";

// TODO: add styles for secondary variant
export function LynxButton(props: LynxButtonProps) {
    const { responsive = true } = props;

    const classes = lynxButtonStyles({ responsive });

    return (
        <Button
            {...props}
            className={clsx(classes.root, props.className)}
            classes={{
                sizeSmall: clsx(classes.small, props.classes?.sizeSmall),
                sizeLarge: clsx(classes.large, props.classes?.sizeLarge),
                focusVisible: clsx(
                    classes.focusVisible,
                    props.classes?.focusVisible
                ),
                disabled: clsx(classes.disabled, props.classes?.disabled),
            }}
        >
            {props.loading ? (
                <Spinner fill="white" className={classes.spinner} />
            ) : (
                props.children
            )}
        </Button>
    );
}
